"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useFlowRun(id) {
  const {
    item: flowRun,
    archive,
    refresh,
    error,
    loading
  } = useElement(
    WorkspaceElementType.FlowRun,
    id,
    (integrationApp) => id ? integrationApp.flowRun(id) : void 0
  );
  return {
    flowRun,
    error,
    loading,
    refresh,
    archive
  };
}

export { useFlowRun };
